import { useState } from "react";

import {
  Box,
  Checkbox,
  Collapse,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { IconButton } from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import AddIcon from "@mui/icons-material/Add";

import useLocalization from "../../hooks/useLocalization";

const DataRow = ({
  columns,
  rowData,
  subTable,
  onRowClick,
  addSubRecord,
  allowSelect,
  onSelect,
  selected,
}) => {
  const theme = useTheme();
  const { getLabel } = useLocalization();

  const [open, setOpen] = useState(false);

  const handleCellClick = (column, id) => {
    if (!column.clickable) return;
    onRowClick(column, id);
  };

  const getValue = (columnName) => {
    let value = "";
    const columnNames = columnName.split(".");

    if (columnNames.length === 1) {
      value = rowData[columnNames[0]];
    } else if (columnNames.length === 2) {
      if (rowData[columnNames[0]] && rowData[columnNames[0]][columnNames[1]]) {
        value = rowData[columnNames[0]][columnNames[1]];
      }
    } else if (columnNames.length >= 3) {
      // Handle 3+ level nesting (e.g., location.address.city)
      let current = rowData;
      for (let i = 0; i < columnNames.length; i++) {
        if (current && typeof current === "object") {
          current = current[columnNames[i]];
        } else {
          current = null;
          break;
        }
      }
      value = current || "";
    }

    return value;
  };

  const subRows = Array.isArray(rowData?.[subTable]) ? rowData[subTable] : [];
  const leadingColumnCount = (subTable ? 1 : 0) + (allowSelect ? 1 : 0);

  return (
    <>
      <TableRow
        key={rowData.id}
        sx={{
          bgcolor: "#fff",
          "&:hover": { bgcolor: theme.palette.primary.light },
        }}
      >
        {subTable ? (
          <TableCell width="30px">
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        ) : null}
        {allowSelect ? (
          <TableCell>
            <Checkbox
              size="small"
              sx={{ padding: "0px" }}
              onChange={(e, checked) => onSelect(checked)}
              checked={selected}
            />
          </TableCell>
        ) : null}
        {columns.map((column) => (
          <TableCell
            key={`${column.name}_${rowData.id}`}
            onClick={() => handleCellClick(column, rowData.id)}
            sx={{
              cursor: column.clickable ? "pointer" : "default",
              width: column.width,
              "&:hover": {
                bgcolor: column.clickable
                  ? theme.palette.primary.main
                  : "inherit",
              },
            }}
          >
            {column.render ? (
              column.render(rowData)
            ) : (
              <Typography
                sx={column.style}
                textAlign={column.textAlign}
              >
                {getValue(column.name)}
              </Typography>
            )}
          </TableCell>
        ))}
      </TableRow>
      {subTable ? (
        <TableRow>
          <TableCell
            colSpan={columns.length + leadingColumnCount}
            style={{ paddingBottom: 0, paddingTop: 0 }}
          >
            <Collapse
              in={open}
              timeout="auto"
              unmountOnExit
            >
              <Box sx={{ marginLeft: "70px" }}>
                <Box
                  display="flex"
                  alignItems="center"
                  gap={2}
                >
                  <Typography variant="subtitle2">{`${getLabel(subTable)} (${subRows.length})`}</Typography>

                  {typeof addSubRecord === "function" ? (
                    <IconButton
                      size="small"
                      onClick={() => addSubRecord(rowData.id)}
                    >
                      <AddIcon />
                    </IconButton>
                  ) : null}
                </Box>
                <Table size="small">
                  <TableHead>
                    <TableCell />
                  </TableHead>
                  <TableBody>
                    {subRows.map((sub, index) => (
                      <TableRow key={`${rowData.id}_${subTable}_${index}`}>
                        <TableCell>{sub.name}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      ) : null}
    </>
  );
};

export default DataRow;
